import { MutableRefObject, useEffect, useRef } from 'react';
import { overviewScrollY$, scrollTop$ } from '../subs';
import { useReframe } from 'nike-re-framejs';
import { SPORT_OVERVIEW_ID } from '../constants';

const useScrollTop: () => [MutableRefObject<any>, string] = () => {
    const ref = useRef(null);
    const derefSub = useReframe();
    const scrollTop = derefSub(scrollTop$);
    const scrollY = derefSub(overviewScrollY$);
    useEffect(() => {
        ref.current?.scrollTo(0, 0);
    }, [ref, scrollTop]);
    useEffect(() => {
        if (scrollY > 0 && ref.current) {
            ref.current.scrollTop = scrollY;
        }
    }, [scrollY]);
    return [ref, SPORT_OVERVIEW_ID];
};

export default useScrollTop;
